require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/core-js/library/fn/object/define-property.js
// module id = 0aOR
// module chunks = 6